import { BehaviorDefinition } from "views/knowledge/components/card";
import { AnswerCardDefinitions } from "views/knowledge/components/card/behaviors/answer";
import { BinderCardDefinitions } from "views/knowledge/components/card/behaviors/binder";
import { ListCardDefinitions } from "views/knowledge/components/card/behaviors/list";
import { PollCardDefinitions } from "views/knowledge/components/card/behaviors/poll";
import { PostCardDefinitions } from "views/knowledge/components/card/behaviors/post";
import { QuestionCardDefinitions } from "views/knowledge/components/card/behaviors/question";

/**
 * Tabela Completa de Definições para montagem dos Cards
 **/
export const PublicationCardDefinitions: Array<BehaviorDefinition> = [
    ...PostCardDefinitions,
    ...PollCardDefinitions,
    ...ListCardDefinitions,
    ...QuestionCardDefinitions,
    ...AnswerCardDefinitions,
    ...BinderCardDefinitions
];
